export default {
  IRR: 'IRR',
  Tomans: 'Tomans'
}
